import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import MainLayout from "./mainLayout/MainLayout";
import {
  shouldShowOnboarding,
  shouldShowUserOnboarding,
  startOnboardingTour,
  startUserOnboardingTour,
} from "../utils/onboardingTour";

const AppLayout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (shouldShowOnboarding()) {
      startOnboardingTour(navigate);
    } else if (shouldShowUserOnboarding()) {
      startUserOnboardingTour(navigate);
    }
  }, []);

  return (
    <div className="flex  w-full flex-col">
      <MainLayout />
    </div>
  );
};

export default AppLayout;
